var React = require('react');
var objectAssign = require('object-assign');
module.exports = function (props) {
    return React.createElement('svg', objectAssign({}, {
        viewBox: '0 0 16 14',
        version: '1.1'
    }, props), React.createElement('title', null), React.createElement('defs', null), React.createElement('g', {
        id: 'Projects',
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none'
    }, React.createElement('g', {
        id: 'Node-Edit',
        transform: 'translate(-48.000000, -201.000000)'
    }, React.createElement('g', {
        id: 'Header-Button',
        transform: 'translate(47.000000, 201.000000)'
    }, React.createElement('rect', {
        id: 'Rectangle-115',
        fill: '#323232',
        x: '1',
        y: '0',
        width: '16',
        height: '4'
    }), React.createElement('path', {
        d: 'M1.02209078,8 L16.9999999,8',
        id: 'Path-262',
        stroke: '#323232',
        strokeWidth: '2'
    }), React.createElement('path', {
        d: 'M1,13 L17,13',
        id: 'Path-262-Copy',
        stroke: '#323232',
        strokeWidth: '2'
    })))));
};


//////////////////
// WEBPACK FOOTER
// ./~/react-icon-loader!./app/images/EditorBold.svg
// module id = 520
// module chunks = 1